import React from 'react'

export function ItemHeadUser() {
  return (
    <>
        <thead>
            <tr className='user-item__header'>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Actions</th>
            </tr>
        </thead>
    </>
  )
}
